import React, {useState, useEffect} from 'react';
import styles from '../../styles/CallCenterQueryType.module.scss';
import Dropdown from '../../component/DropDown/DropDown';
import SearchInput from '../../component/SearchInput/SearchInput';
import {Times, ViewPen} from '../../assets/icons';
import CallCenterStructure from '../CallCenterStructure/CallCenterStructure';
import axiosProperty from '../../service/HttpConfig';
import ApiConfig from '../../service/ApiConfig';
import swal from 'sweetalert';
import {Headers, CallCenterHeaders, ProgramID } from '../../service/Essentials';
import {useQuery, useMutation, useQueryClient} from 'react-query';
import MenuDeleteModal from '../../component/MenuDeleteModal/MenuDeleteModal';
//import Paginate from '../../component/Paginate/Paginate';
import { getUser } from '../../service/common';
import ClearInputModal from '../../component/ClearInputModal/ClearInputModal';


const CallCenterQueryType = () => {
  const user = getUser();
  const [clearModal, setClearModal] = useState(false);

  const program_id = ProgramID();

  const dataString = sessionStorage.getItem('profile');
  if (dataString) {
    var profile = JSON.parse(dataString);
  } else {
    profile = {};
  }

  const queryClient = useQueryClient();
  const [page, setPage] = useState(1);
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState('oops... something went wrong');
  const [errors, setErrors] = useState({
    Company_id: '',
    Membership_id: '',
    Query_type_name: '',
    User_type_id: '',
    User_group_id: '',
    User_name: '',
  });
  const [queryName, setQueryName] = useState('');
  const membership_id = 7744889018; // profile?.Membership_id;
  const [userTypeID, setUserTypeID] = useState('');
  const [userType, setUserType] = useState();
  const [userGroupID, setUserGroupID] = useState();
  const [userGroup, setUserGroup] = useState();
  const [userName, setUserName] = useState();
  const [userNameID, setUserNameID] = useState();
  const [isUpdate, setIsUpdate] = useState(false);
  const [isSubmit, setIsSubmit] = useState(true);
  const [updateID, setUpdateID] = useState();
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedItemID, setSelectedItemId] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const [formData, setFormData] = useState({
    Company_id: program_id,
    Membership_id: membership_id,
    Query_type_name: '',
    User_type_id: userTypeID,
    User_group_id: userGroupID,
    User_name: userName,
  });

  //console.log(formData);

  const handleUserType = name => {
    setUserType(name);
  };
  const handleUserTypeID = id => {
    setUserTypeID(id);
    setFormData(prevFormData => ({
      ...prevFormData,
      User_type_id: id,
    }));
  };

  const handleUserGroup = name => {
    setUserGroup(name);
  };
  const handleUserGroupID = id => {
    setUserGroupID(id);
    setFormData(prevFormData => ({
      ...prevFormData,
      User_group_id: id,
    }));
  };

  const handleUserName = name => {
    setUserName(name);
  };
  const handleUserNameID = id => {
    setUserNameID(id);
    setFormData(prevFormData => ({
      ...prevFormData,
      User_name_id: id,
    }));
  };

  const fetchQueryTypes = async page => {
    const res = await axiosProperty.get(ApiConfig.fetchQueryTypes(7744889018), {
      headers: CallCenterHeaders(),
    });
    return res.data;
  };

  const {data, status} = useQuery(
    ['querytypes', page],
    () => fetchQueryTypes(page),
    {keepPreviousData: true},
  );

  useEffect(() => {
    setFilteredData(data?.data || []);
  }, [data]);

  const handleSearchInputChange = searchTerm => {
    setSearchTerm(searchTerm);
    if (searchTerm === '') {
      setFilteredData(data?.data || []); // Reset to original data if search term is empty
    } else if (data?.data) {
      const filtered = data.data.filter(item =>
        item.Query_type_name.toLowerCase().includes(searchTerm.toLowerCase()),
      );
      setFilteredData(filtered);
    }
  };

  const handleChange = e => {
    const {name, value} = e.target;
    setFormData({...formData, [name]: value});
  };

  const addQueryType = async () => {
    //e.preventDefault();
    //setData(prev => [...prev, {id: 4, name: text}]);
    // return
    try {
      const res = await axiosProperty.post(
        ApiConfig.createQueryType,
        formData,
        {
          headers: CallCenterHeaders(),
        },
      );
      if (res.status === 200) {
        setFormData({
          Company_id: program_id,
          Membership_id: membership_id,
          Query_type_name: '',
          User_type_id: '',
          User_group_id: '',
          User_name: '',
        });
        setErrors({});
        setUserGroupID('');
        setUserGroup('');
        setUserType('');
        setUserTypeID('');
        setUserName('');
        setUserNameID('');
        swal({
          title: 'Success!',
          text: 'Query Type added successfully',
          icon: 'success',
        });
      } else {
        setError('Something went wrong with the request');
        swal({
          title: 'Error!',
          text: 'Something went wrong with the request',
          icon: 'error',
        });
      }
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message);
        setErrors(err.response.data.errors);
        swal({
          title: 'Error!',
          text: error,
          icon: 'error',
        });
      } else {
        setError('Something went wrong, probably network');
        swal({
          title: 'warning!',
          text: error,
          icon: 'error',
        });
      }
      console.log(err);
    }
  };

  const {mutate: addQueryTypeMutation} = useMutation({
    mutationFn: addQueryType,
    onSuccess: () => {
      queryClient.invalidateQueries(['querytypes']);
    },
  });

  const updateQueryType = async () => {
    try {
      const res = await axiosProperty.put(
        ApiConfig.updateQueryType(updateID),
        formData,
        {
          headers: CallCenterHeaders(),
        },
      );

      if (res.status === 200) {
        setIsSubmit(true);
        setIsUpdate(false);
        setUserGroupID('');
        setUserGroup('');
        setUserType('');
        setUserTypeID('');
        setUserName('');
        setUserNameID('');
        setFormData({
          Company_id: program_id,
          Membership_id: membership_id,
          Query_type_name: '',
          User_type_id: '',
          User_group_id: '',
          User_name: '',
        });
        setErrors({});
        swal({
          title: 'Success!',
          text: 'Query Type updated successfully',
          icon: 'success',
        });
      } else {
        setError('Something went wrong with the request');
        swal({
          title: 'Error!',
          text: 'Something went wrong with the request',
          icon: 'error',
        });
      }
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message);
        setErrors(err.response.data);
        swal({
          title: 'Error!',
          text: error,
          icon: 'error',
        });
      } else {
        setError('Something went wrong, try again');
        swal({
          title: 'Warning!',
          text: error,
          icon: 'warning',
        });
      }
    }
  };

  const {mutate: updateQueryTypeMutation} = useMutation({
    mutationFn: updateQueryType,
    onSuccess: () => {
      queryClient.invalidateQueries(['querytypes']);
    },
  });

  const editQueryType = async id => {
    try {
      const res = await axiosProperty.get(ApiConfig.editQueryType(id), {
        headers: CallCenterHeaders(),
      });
      setIsUpdate(true);
      setIsSubmit(false);
      setFormData(prevFormData => ({
        ...prevFormData,
        Company_id: program_id,
        Membership_id: membership_id,
        Query_type_name: res.data.data.Query_type_name,
        User_type_id: res.data.data.User_type_id,
        User_group_id: res.data.data.User_group_id,
        User_name: res.data.data.User_name,
      }));
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message);
      } else {
        setError('Something went wrong, try again');
      }
      swal({
        title: 'Warning!',
        text: error,
        icon: 'warning',
      });
    }
  };

  const deleteQueryType = async id => {
    try {
      const res = await axiosProperty.delete(ApiConfig.deleteQueryType(id), {
        headers: CallCenterHeaders(),
      });
      //setSuccessModal(true);
      setDeleteModal(false);

      swal({
        title: 'Success!',
        text: 'Delete was successful',
        icon: 'success',
      });
      queryClient.invalidateQueries(['querytypes']);
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message);
      } else {
        setError('Something went wrong, try again');
      }
      console.log(err);
      swal({
        title: 'Warning!',
        text: error,
        icon: 'warning',
      });
    }
  };

  const onClose = () => {
    setDeleteModal(false);
  };

  return (
    <div>
      <CallCenterStructure>
        <div className={styles.CallCenterQueryType}>
          <div className={styles.headerText}>
            <p>Call Center Query Type</p>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.field1}>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Enter Query Type<sup>*</sup>
                </label>
                <input
                  onChange={handleChange}
                  value={formData.Query_type_name}
                  type="text"
                  name="Query_type_name"
                  id=""
                />
                {errors?.Query_type_name && (
                  <p className="text-danger">{errors?.Query_type_name}</p>
                )}
              </div>
            </div>
            <div className={styles.middleText}>
              <p>Contact Details for Resolve Query</p>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Select User Type<sup>*</sup>
                </label>
                <Dropdown
                  header={Headers()}
                  api={ApiConfig.fetchUserType}
                  onSelect={handleUserTypeID}
                  onSelectOption={handleUserType}
                  retrievedValue={formData.User_type_id}
                  column={'name'}
                  key="usertypes_query_type"
                />
              </div>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">
                  Select User Group<sup>*</sup>
                </label>
                <Dropdown header={Headers()} api={ApiConfig.fetchUserGroup} onSelect={handleUserGroupID} onSelectOption={handleUserGroup} retrievedValue={formData.User_group_id} column={'user_group_name'} key="usergroups_query_type" />
              </div>
            </div>
            <div className={styles.field2}>
              <div className={styles.fieldContainer1}>
                <label htmlFor="">Select User Name</label>
                <Dropdown
                  onSelect={handleUserNameID}
                  onSelectOption={handleUserName}
                  retrievedValue={userNameID}
                  column={'name'}
                  key="usernames"
                />
              </div>
            </div>
            <div className={styles.buttonContainer}>
              {isSubmit && (
                <button
                  className={styles.submit}
                  onClick={() => addQueryTypeMutation()}>
                  Submit
                </button>
              )}
              {isUpdate && (
                <button
                  className={styles.submit}
                  onClick={() => updateQueryTypeMutation()}>
                  Update
                </button>
              )}
              <button
                className={styles.reset}
                type="button"
                onClick={() => setClearModal(true)}>
                Reset
              </button>
            </div>
          </div>
          <div className={styles.tableSection}>
            <div className={styles.searchInputContainer}>
              <div className={styles.searchInput}>
                <SearchInput onSearchInputChange={handleSearchInputChange} />
              </div>
              <button className={styles.searchBTN}>Search</button>
            </div>
            <div className={styles.innerTableContainer}>
              <table className={styles.mainTable}>
                <thead>
                  <tr>
                    <th>Query Type</th>
                    <th>User Type</th>
                    <th>User Group</th>
                    <th>User Name</th>

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map(each => (
                    <tr key={each.Query_type_id}>
                      <td>{each.Query_type_name}</td>
                      <td>{each?.User_type_name}</td>
                      <td>{each?.User_group_name}</td>
                      <td>{each?.User_name}</td>

                      <td>
                        <div className={styles.iconContainer}>
                          <span
                            className={styles.icon}
                            onClick={() => {
                              editQueryType(each.Query_type_id);
                              setUpdateID(each.Query_type_id);
                            }}>
                            <ViewPen />
                          </span>
                          <span
                            className={styles.icon}
                            onClick={() => {
                              setDeleteModal(true);
                              setSelectedItemId(each.Query_type_id);
                            }}>
                            <Times />
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {/* Pass your clear input function to clearInputFn */}
          <ClearInputModal
            // clearInputFn={handleReset}
            clearModalStatus={clearModal}
            clearInputModalState={setClearModal}
          />
          {deleteModal && (
            <MenuDeleteModal
              onClose={onClose}
              onDelete={() => deleteQueryType(selectedItemID)}
            />
          )}
        </div>
      </CallCenterStructure>
    </div>
  );
};

export default CallCenterQueryType;
